require('./RAImageIcon.scss');

const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

class RAImageIcon extends React.Component {
    render() {
        const { extraClass, iconType } = this.props;

        const className = classnames('ra-image-icon', extraClass, {
            [`ra-image-icon-${iconType}`]: !!iconType,
        });

        return <i className={className} />;
    }
}

RAImageIcon.propTypes = {
    extraClass: PropTypes.string,
    iconType: PropTypes.string.isRequired,
};

module.exports = RAImageIcon;
